export default "__VITE_ASSET__DzJi$wAr__"